query GetTriviaLeaderboard($eventId: ID!, $includeStaff: Boolean) {
  leaderboard: StreamToolsGetTriviaLeaderboard(eventId: $eventId, includeStaff: $includeStaff) {
    eventId
    revealedQuestionCount
    includeStaff
    computedAt
    twitch {
      rank
      displayName
      correct
      answered
      isBroadcaster
      isModerator
    }
    youtube {
      rank
      displayName
      correct
      answered
      isBroadcaster
      isModerator
    }
    questions {
      triviaId
      question
      twitchCorrect
      twitchAnswered
      twitchPct
      youtubeCorrect
      youtubeAnswered
      youtubePct
      youtubeRemoved
    }
  }
}
